function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleHung(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 48,
    viewBox: "0 0 85 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M40.9167 22.4166H44.0833M25.7167 43H59.2833M28.8833 5H56.1166V43H28.8833V5ZM32.05 8.15719H52.95V23.9905H32.05V8.15719ZM32.05 24H52.95V39.8333H32.05V24Z",
    stroke: "#1D1D1B",
    style: {
      stroke: "#1D1D1B",
      stroke: "color(display-p3 0.1137 0.1137 0.1059)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2349,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleHung);
export default __webpack_public_path__ + "static/media/Double-hung.01843dead66ee123bc3c719d1dae0f9a.svg";
export { ForwardRef as ReactComponent };